import React from "react";
import AuthContext from "./AuthContext";
import { getLocalStorageItem } from "../general/LocalStorageManager";

function useAuth() {
    // Get Auth User from LocalStorageManager.
    let user = getLocalStorageItem("pg-token");

    return React.useContext(AuthContext);
}

export { useAuth };